import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'duplicate-btn-cell-renderer',
    template: `
      <button (click)="onDuplicateBtn($event)" [disabled]="this.datesComparision()">{{this.label}}</button>
    `,
    standalone: false
})
  export class HhgRatesBidcyclesDuplicateButtonRendererComponent implements ICellRendererAngularComp {
    refresh(params?: any): boolean {
      return true;
    }
    label: string;
    private params: any;
  
    agInit(params: any): void {
      this.params = params;
      this.label = this.params.label;
    }

    datesComparision(){
      if((new Date()) > new Date(this.params.data.bidWindowCloseDate)) return false;
      else return true;
    }
  
    onDuplicateBtn($event) {
      this.params.onClick(this.params.data);
      console.log(this.params);
    }
  }